"use client"

import { useAppRouter } from "@/hooks/app/useAppRouter"
import { useCurrentPrice } from "@/hooks/product_detail/useCurrentPrice"
import { useProductName } from "@/hooks/product_detail/useProductName"
import { useSelectedAspect } from "@/hooks/product_detail/useSelectedAspect"
import { useSelectedVariant } from "@/hooks/product_detail/useSelectedVariant"
import { useAppDispatch, useAppSelector } from "@/hooks/redux"
import { useStoreData } from "@/hooks/store/useStoreData"
import { productActions } from "@/lib/redux/features/product/reduce"
import { Button } from "antd"
import { useParams } from "next/navigation"

const ProductAddToCartButton = () => {
  const dispatch = useAppDispatch()
  const pType = useAppSelector(state => state.product.design_detail.data.p_type)
  const no_design = useAppSelector(state => state.product.design_detail.data.no_design)
  const default_image = useAppSelector(state => state.product.design_detail.data.default_image)
  const productId = useAppSelector(state => state.product.design_detail.data.id)
  const bundle = useAppSelector(state => state.product.design_detail.data.bundle)
  const bundleData = useAppSelector(state => state.product.design_detail.data.bundle_data)
  const quantity = useAppSelector(state => state.product.quantity)

  const productName = useProductName()
  const { store } = useStoreData()
  const { price, compare_at_price } = useCurrentPrice()
  const selectedVariant = useSelectedVariant()
  const { aspect: selectedAspect } = useSelectedAspect()
  const router = useAppRouter()
  
  return (
    <Button
      block
      htmlType="button"
      aria-label="Add product to cart"
      size="large"
      type="primary"
      style={{ height: "5rem" }}
      onClick={() => {
        dispatch(productActions.addProductToCart({
          productId: productId || selectedVariant?.store_product_id,
          productName: productName,
          store_id: store.store_id,
          price: price,
          compare_at_price: compare_at_price,
          quantity: quantity,
          preview: bundle
            ? default_image
            : selectedVariant?.images[0][selectedAspect?.aspect_group_label || selectedAspect?.label || ""]
            || selectedVariant?.images[0][selectedAspect?.label || selectedAspect?.aspect_group_label || ""]
            || "",
          variant: selectedVariant,
          products: bundle ? bundleData : [],
          p_type: pType,
          noDesign: !!no_design,
        }))
        router.push('/cart')
      }}
    >
      ADD TO CART
    </Button>
  )
}

export default ProductAddToCartButton